import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoadFocus } from 'Src/ng2/store/actions/focus-actions/focus-actions';
import { IFocusPayload } from 'Src/ng2/store/actions/focus-actions/focus-actions';
import { getFocusData, getFocusLoadedStatus } from 'Src/ng2/store/selectors/focus-selectors/focus-selectors';

@Injectable()
export class FocusResolver {
  resolveFocusData$(store: Store<any>, payload: IFocusPayload): Promise<Observable<any>> {
    const destroy$: Subject<boolean> = new Subject<boolean>();
    return new Promise(resolve => {
      store
        .select(getFocusLoadedStatus)
        .pipe(takeUntil(destroy$))
        .subscribe((loaded: boolean) => {
          if (!loaded) store.dispatch(new LoadFocus(payload));
          if (loaded) {
            const focusData$ = store.select(getFocusData);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(focusData$);
          }
        });
    });
  }
}
